export default __webpack_public_path__ + "static/media/diner.ea352e9b.svg";